/*jshint esversion: 9 */
// import React from "react";
// import { Fragment } from "react";
import { connect } from "react-redux";
//import { withStyles } from "@material-ui/core/styles";
// import { doLog, notNull, updateObject } from "../../shared/utility";
import { notNull, updateObject } from "../../shared/utility";

import * as actions from "../../store/actions/index";
// import classes from "../CrimeSubmission.css";
// import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";

const mappedSelectPropFields = [];

const mappedTextPropFields = [
  "ORI",
  "INCIDENTTYPE",
  "SECTIONNAME",
  "FIELDNAME",
  "REQUIRE",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

// const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
// const quote = '"';
// const singleQuote = "'";

class ManageRequiredField extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    keyFieldValue: null,
    //
    requiredFieldIndex: -1,
    sectionName: "ManageRequireField",
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    ORI: {
      inputType: "text",
      value: "",
      default: "",
      label: "ORIe",
      maxSize: 9,
      validation: { required: true },
      upperOnly: true,
    },
    INCIDENTTYPE: {
      inputType: "text",
      value: "",
      default: "",
      label: "Incident Type",
      maxSize: 12,
      validation: { required: true },
      upperOnly: true,
    },
    SECTIONNAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Section",
      maxSize: 50,
      disabled: true,
      validation: { required: false },
    },
    FIELDNAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Field",
      maxSize: 50,
      disabled: true,
      validation: { required: false },
    },
    REQUIRE: {
      inputType: "checkbox",
      value: "",
      label: "Required",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
  };

  componentDidMount() {
    // if (doLog()) console("[ManageRequiredField] componentDidMount");
    // if (doLog()) console("[ManageRequiredField] componentDidMount state:", this.state);
    // if (doLog()) console("[ManageRequiredField] componentDidMount props:", this.props);
    this.copyFieldValuesToState();
  }

  componentDidUpdate() {
    // if (doLog()) console("[ManageRequiredField] componentDidUpdate");
    // if (doLog()) console("[ManageRequiredField] componentDidUpdate state:", this.state);
    // if (doLog()) console("[ManageRequiredField] componentDidUpdate props:", this.props);
  }

  copyFieldValuesToState() {
    // if (doLog()) console(
    //   "[ManageRequiredField]copyFieldValuesToState item:",
    //   this.props.item
    // );
    if (this.props.item !== null) {
      const item = this.props.item;
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        // if (doLog()) console(
        //   "[ManageRequiredField]copyFieldValuesToState text field:",
        //   fieldName
        // );
        const newValue = notNull(item[fieldName]);
        // if (doLog()) console(
        //   "[ManageRequiredField]copyFieldValuesToState text newValue:",
        //   newValue
        // );
        if (fieldName === "REQUIRE") { // Set the label to the fieldname
          this.setState({
            [fieldName]: updateObject(this.state[fieldName], {
              value: newValue,
              label: item.FIELDNAME,
            }),
          });
        } else {
          this.setState({
            [fieldName]: updateObject(this.state[fieldName], {
              value: newValue,
            }),
          });
        }
        if (this.state[fieldName].keyField === true) {
          this.setState({ keyFieldValue: notNull(item[fieldName]) });
        }
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        // if (doLog()) console(
        //   "[ManageRequiredField]copyFieldValuesToState select field:",
        //   fieldName
        // );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: notNull(item[fieldName]),
          }),
        });
      }

      const fields = {
        ORI: updateObject(this.state.ORI, {
          value: item.ORI,
        }),
        INCIDENTTYPE: updateObject(this.state.INCIDENTTYPE, {
          value: item.INCIDENTTYPE,
        }),
        SECTIONNAME: updateObject(this.state.SECTIONNAME, {
          value: item.SECTIONNAME,
        }),
        FIELDNAME: updateObject(this.state.FIELDNAME, {
          value: item.FIELDNAME,
        }),
        REQUIRE: updateObject(this.state.REQUIRE, {
          value: item.REQUIRE,
        }),
      };

      this.setState({ requiredFieldIndex: this.props.index });
    //   if (doLog()) console(
    //     "[ManageRequiredField] componentDidMount requiredFieldIndex:",
    //     this.props.index
    //   );

      this.props.onNewControl(this.props.index, fields);
    }
  }

  render() {
    return (
      this.getFormField("REQUIRE", false, true)
    );
  }
}

const mapStateToProps = (state) => {
//   if (doLog()) console("[ManageRequiredField] mapStateToProps state:", state);
  return {
    requiredFieldArray: state.trans.requiredFieldArray,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetRequiredFieldArray: (requiredFieldArray) =>
      dispatch(actions.setRequiredFieldArray(requiredFieldArray)),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageRequiredField)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageRequiredField);
